<div >
  <div class="header d-flex justify-content-between align-items-center">
    <h2 class="m-0" mat-dialog-title>{{data.title}}</h2>
    <button mat-icon-button [mat-dialog-close]="false">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <div mat-dialog-content >
    <div class="text-center">
      <div class="content">
        <span class="titre">{{data.message}}</span>
      </div>
    </div>

    <div *ngIf="data.frame">
      <mat-form-field appearance="outline" class="w-100" *ngIf="data.field=='textarea'">
        <mat-label>Motif de refus</mat-label>
        <textarea matInput placeholder="Motif de refus" cols="5" [(ngModel)]="returnedValue"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-100" *ngIf="data.field=='date'">
        <mat-label>Date de publication de la trame</mat-label>
        <input matInput type="date" placeholder="XX/XX/XXXX" [(ngModel)]="returnedValue" [min]="dateString">
      </mat-form-field>
    </div>


    <div class="bottom group-btn" *ngIf="data.isAlert !== true" >
      <div *ngIf="client != 'adisco'" class="d-flex justify-content-between">
        <button class="btn btn-outline-primary" (click)="cancel()">{{ data.cancelText || 'ANNULER'}}</button>
        <button class="btn btn-outline-primary" (click)="confirmer()">{{ data.confirmText || 'CONFIRMER'}}</button>
      </div>
      <div *ngIf="client == 'adisco'" class="d-flex justify-content-between">
        <button class="btn btn-adisco btn-outline-primary" (click)="cancel()">{{ data.cancelText || 'ANNULER'}}</button>
        <button class="btn btn-adisco btn-outline-primary" (click)="confirmer()">{{ data.confirmText || 'CONFIRMER'}}</button>
      </div>
    </div>
  
  </div>
</div>
